import { createContext, useContext, useEffect, useMemo, useState } from "react";

const AudienceContext = createContext({ audience: "privat", setAudience: () => {} });

export const AudienceProvider = ({ children }) => {
  const [audience, setAudience] = useState(() => {
    if (typeof window === "undefined") return "privat";
    return window.localStorage.getItem("livinora.audience") || "privat";
  });

  useEffect(() => {
    try {
      window.localStorage.setItem("livinora.audience", audience);
    } catch (err) {
      // Storage may be unavailable (Safari private mode, disabled cookies).
      // Non-fatal — surface it once for debuggability and move on.
      // eslint-disable-next-line no-console
      console.warn("[AudienceContext] localStorage persist failed:", err);
    }
  }, [audience]);

  const value = useMemo(() => ({ audience, setAudience }), [audience]);

  return <AudienceContext.Provider value={value}>{children}</AudienceContext.Provider>;
};

export const useAudience = () => useContext(AudienceContext);
